import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Add_Customer.css";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Topbar from "../Topbar/Topbar";

export default function View_Customer() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const locate = useLocation();
  const [customerDetails, setCustomerDetails] = useState({});
  const [originalData, setOriginalData] = useState({});
  const [error, setError] = useState("");
  const [error1, setError1] = useState("");
  const [errorrefund, setErrorRefund] = useState("");
  const [errorinstalltioncharge, setErrorinstallationcharge] = useState("");
  const [receivedDataCustomer, setReceivedDataCustomer] = useState(
    locate.state?.customerid || ""
  );

  useEffect(() => {
    axios
      .post(apiUrl + "getdata", {
        customerid: locate.state?.customerid,
      })
      .then((res) => {
        setCustomerDetails(res.data.message);
        setOriginalData(res.data.message); // Store original data for comparison
      });
  }, [locate.state?.customerid]);

  const handleChange = (e) => {
    setCustomerDetails({
      ...customerDetails,
      [e.target.name]: e.target.value,
    });
  };
  console.log(customerDetails, 47);
  const handlePhoneNumberBlur = () => {
    const regex = /^[0-9]{10}$/;
    if (!regex.test(customerDetails.contactnum || "")) {
      setError("Please enter a valid 10-digit phone number");
    } else {
      setError("");
    }
  };
  const handlePhoneNumberBlur1 = () => {
    const regex1 = /^[0-9]{10}$/;
    if (!regex1.test(customerDetails.alternatenum || "")) {
      setError1("Please enter a valid 10-digit phone number");
    } else {
      setError1("");
    }
  };

  const [value, setValue] = useState("");

  const handledecimal = (e) => {
    const inputValue = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(inputValue)) {
      setValue(inputValue);
    }
  };

  const [value1, setValue1] = useState("");

  const handledecimal1 = (e) => {
    const inputValue1 = e.target.value;
    const regex1 = /^\d*\.?\d{0,2}$/;
    if (regex1.test(inputValue1)) {
      setValue1(inputValue1);
    }
  };

  const handlerefunddeposit = (e) => {
    setCustomerDetails({ ...customerDetails, refunddeposit: e.target.value });
    handledecimal(e);
  };

  const handleintallationcharge = (e) => {
    setCustomerDetails({
      ...customerDetails,
      installationcharge: e.target.value,
    });
    handledecimal1(e);
  };

  const navigate = useNavigate();

  const gotoEditCustomer = (e) => {
    e.preventDefault();
    navigate("/edit_customer", { state: { customerid: receivedDataCustomer } });
  };

  const updateCustomerData = (e) => {
    e.preventDefault();

    // Validate phone numbers
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(customerDetails.contactnum || "")) {
      setError("Please enter a valid 10-digit phone number");
      return;
    }

    // Validate decimal inputs (installation charge and refund deposit)

    const decimalRegex1 = /^\d*\.?\d{0,2}$/;
    if (!decimalRegex1.test(customerDetails.installationcharge || "")) {
      // alert("Please enter a valid installation charge (up to 2 decimal places)");
      setErrorinstallationcharge(
        "Please enter a valid refund deposit (up to 2 decimal places"
      );

      return;
    }

    const decimalRegex = /^\d*\.?\d{0,2}$/;
    if (!decimalRegex.test(customerDetails.refunddeposit || "")) {
      // alert("Please enter a valid refund deposit (up to 2 decimal places)");
      setErrorRefund(
        "Please enter a valid refund deposit (up to 2 decimal places"
      );

      return;
    }

    // Check if any field has changed
    const isDataChanged = Object.keys(originalData).some(
      (key) => customerDetails[key] !== originalData[key]
    );

    if (!isDataChanged) {
      // alert("Nothing to update");

      Swal.fire({
        title: "<strong>Nothing to update </strong>",
        icon: "info",
        // html: `
        //   You can use <b>bold text</b>,
        //   <a href="#" autofocus>links</a>,
        //   and other HTML tags
        // `,
        showCloseButton: true,

        focusConfirm: false,
      });

      return;
    }
    try {
      axios.post(apiUrl + "update", customerDetails).then((res) => {
        // alert(res.data.Message);
        Swal.fire({
          title: "Customer Details Updated Successfully!..",
          icon: "success",
          draggable: true,
        }).then(() => {
          navigate("/customersection");
        });

        console.log(res.data);
      });
    } catch (error) {
      console.log("Error submitting data", error);
    }
  };
  const handleBack = () => {
    navigate("/customersection");
  };

  console.log(customerDetails.lastrenewaldate, 181);
  const getAccountStatusClass = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "active":
        return "status-active";
      case "inactive":
        return "status-inactive";
      case "suspended":
        return "status-suspended";
      case "disabled":
        return "status-disable";
      case "expired":
        return "status-expired";
     
      default:
        return "";
    }
  };

  const getDeviceStatusClass = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "online":
        return "device-online";
      case "offline":
        return "device-offline";
      default:
        return "";
    }
  };

  return (
    <>
      <Topbar />
      <Container className="mt-1  margin-right ">
        <form onSubmit={updateCustomerData}>
          <Row>
            <Col>
              <h3>Customer</h3>
            </Col>

            <Col className="mx-5 text-end">
              <button
                className=" blue-btn  px-4 text-white"
                onClick={handleBack}
              >
                Back
              </button>
              {/*<button
                type="button"
                className="black-btn mx-3"
                onClick={gotoEditCustomer}
              >
                {" "}
                <MdEdit size={18} /> Edit
              </button>*/}
              {/*         
              <button
                className=" blue-btn  px-4 text-white"
                value="submit"
                type="submit"
              >
                Submit
              </button> */}
            </Col>
          </Row>

          <div className="border-container1">
            <h6 className="form-head  m-0 text-white  ">Customer Details</h6>
          </div>

          <div className="border-container">
            <Row>
              <Col sm={12} md={6}>
                <Row>
                  <Col sm={12} md={6} className="text-start">
                    <lable sm={12} className="rowdown ">
                      Customer Id
                    </lable>
                    <br />
                    <input
                      sm={12}
                      type="text"
                      name="customerid"
                      value={customerDetails.customerid || ""}
                      onChange={handleChange}
                      className="form-input"
                      disabled
                      placeholder="Enter Customer Id"
                      readOnly
                    />
                  </Col>

                  <Col sm={12} md={6} className="text-start">
                    <lable className="rowdown"> Plan Name</lable>
                    <br />
                    <input
                      type="text"
                      name="planname"
                      value={customerDetails.planname || ""}
                      onChange={handleChange}
                      className="form-input"
                      disabled
                      placeholder="Enter Plan Name"
                    />
                  </Col>
                </Row>
              </Col>
              <Col sm={12} md={6} className="text-start ">
                <lable>Customer Name</lable>
                <br />
                <input
                  type="text"
                  name="customername"
                  value={customerDetails.customername || ""}
                  onChange={handleChange}
                  style={{ textTransform: "capitalize " }}
                  className="form-input inputfield "
                  placeholder="Enter Customer Name"
                  disabled
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6} className="text-start">
                <lable>Installation Address</lable>
                <br />
                <textarea
                  type="text"
                  name="installationadd"
                  value={customerDetails.installationadd || ""}
                  onChange={handleChange}
                  style={{ textTransform: "capitalize", resize: "none" }}
                  className=" box inputfield"
                  placeholder="Enter Installtion Address"
                  disabled
                />
              </Col>

              <Col>
                <Col xs={12} md={12}>
                  <Row>
                   <Col xs={12} md={6} className="text-start">
                    <lable>Account Status</lable>
                    <br />
                    {/* <input
                    
                      className="field form-input "
                      name="accountstatus"
                      value={customerDetails.accountstatus || ""}
                      onChange={handleChange}
                      type="text"
                      disabled
                      placeholder="Enter"
                    /> */}
                    <input
                    style={{marginLeft:"-3px"}}
                      type="text"
                      className={`field form-input  ${getAccountStatusClass(
                        customerDetails.accountstatus
                      )}`}
                      value={customerDetails.accountstatus || ""}
                      onChange={handleChange}
                      name="accountstatus"
                      readOnly
                      placeholder="Enter"
                    />

                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Device Status</lable>
                    <br />

                    <input
                     style={{marginLeft:"-3px"}}
                    className={`field form-input me-2 ${getDeviceStatusClass(
                        customerDetails.devicestatus
                      )}`}
                      name="devicestatus"
                      value={customerDetails.devicestatus || ""}
                      onChange={handleChange}
                      type="text"
                     readOnly
                      placeholder="Enter"
                    />
                  </Col>
                  </Row>
                </Col>
                <Row>
                  <Col xs={12} md={6} className="text-start mt-3">
                    <lable>Activation Date</lable>
                    <br />
                    <input
                      name="activationdate"
                      value={customerDetails.activationdate || ""}
                      onChange={handleChange}
                      className="field form-input"
                      type="text"
                      placeholder="Enter"
                      disabled
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start mt-3">
                    <lable>Contact Number</lable>
                    <br />
                    <input
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onBlur={handlePhoneNumberBlur}
                      name="contactnum"
                      value={customerDetails.contactnum || ""}
                      onChange={handleChange}
                      required
                      disabled
                      placeholder="Enter Phone Number"
                      className="form-input"
                    />
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6} className="text-start">
                <lable>Billing Address</lable>
                <br />
                <textarea
                  style={{ textTransform: "capitalize", resize: "none" }}
                  name="billingadd"
                  value={customerDetails.billingadd || ""}
                  onChange={handleChange}
                  type="text"
                  className="box inputfield"
                  placeholder=" Billing Address"
                  disabled
                />
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Expiry Date</lable>
                    <br />

                    <input
                      className="field form-input"
                      name="expirydate"
                      value={customerDetails.expirydate || ""}
                      onChange={handleChange}
                      disabled
                      type="text"
                      placeholder="Enter"
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Last Renewal Date</lable>
                    <br />
                    <input
                      className="field form-input"
                      name="lastrenewaldate"
                      value={customerDetails.lastrenewaldate || ""}
                      onChange={handleChange}
                      type="text"
                      disabled
                      placeholder="Enter"
                    />
                  </Col>
                </Row>

                <Row>
                   <Col xs={12} md={12} className="text-start mt-3">
                      <lable className="mt-2">Mail Id</lable>
                      <br />
                      <input
                        type="email"
                        name="mailid"
                        disabled
                        value={customerDetails.emailid || ""}
                        onChange={handleChange}
                        className="form-form-input inputfield"
                        placeholder="Enter Email ID"
                      />
                    </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </form>
      </Container>
    </>
  );
}
